import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { verifyRefid, createPortalUserSalesRefid } from '../../api'
import Button from '../../components/button'
import Input from '../../components/input'
import Select from '../../components/select'
import { ErrorMessage } from '../../components/error-message'
import { Redirect, Link, useParams, withRouter } from 'react-router-dom'
import LoadingPage from '../loading'

const Container = styled.div`
  background: #FFF;
	border-radius: 8px;
	box-shadow: 0px 0px 8px 0px #e1e2e6;
  width: 100%;
  padding: 24px;

  @media(max-width: 900px) {
    padding: 16px;
  }
`

const Instructions = styled.p`
  margin: 20px 0;
`

const SignUp = (props) => {
  const [refidChecked, updateRefidChecked] = useState(null)
  const [refidValid, updateRefidValid] = useState(null)
  const [created, updateCreated] = useState(false)
  const [name, updateName] = useState('')
  const [email, updateEmail] = useState('')
  const [phone, updatePhone] = useState('')
  const [accountType, updateAccountType] = useState({ label: "Coach", value: "0" })
  const [nameError, updateNameError] = useState(false)
  const [emailError, updateEmailError] = useState(false)
  const [phoneError, updatePhoneError] = useState(false)
  const [error, updateError] = useState('')
  const params = useParams()

  useEffect(() => {
    if (refidChecked === null) {
      updateRefidChecked(false)
      verifyRefid(params.refid).then((res) => {
        updateRefidValid(res.data.valid)
        updateRefidChecked(true)
      })
    }
  }, [refidChecked, params.refid])

  const handleSubmit = () => {
    // eslint-disable-next-line
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

    if (!name) {
      updateError('Please enter your name.')
      updateNameError(true)
    } else {
      updateNameError(false)
      if (!email) {
        updateError('Please enter your email address.')
        updateEmailError(true)
      } else if (!re.test(email)) {
        updateError('The email address you entered is invalid.')
        updateEmailError(true)
      } else {
        updateEmailError(false)
        if (!phone) {
          updateError('Please enter your phone number.')
          updatePhoneError(true)
        } else {
          updateError('')
          updatePhoneError(false)
          const data = {
            name: name,
            email_address: email,
            phone_number: phone,
            is_gym: parseInt(accountType.value),
          }
          createPortalUserSalesRefid(params.refid, data).then((res) => {
            if (res.data.error) {
              updateError(res.data.error)
            } else {
              updateCreated(true)
            }
          })
        }
      }
    }
  }

  return (
    refidChecked !== true ? (
      <LoadingPage />
    ) : (!refidValid ? (
      <Redirect to='/' />
    ) : (
      <Container>
        <Instructions>Use this form to create your own portal account.</Instructions>
        <Input
          error={nameError}
          label="Name"
          value={name}
          onChange={updateName}
        />
        <Input
          error={emailError}
          label="Email"
          value={email}
          onChange={updateEmail}
        />
        <Input
          error={phoneError}
          label="Phone Number"
          value={phone}
          onChange={updatePhone}
        />
        <Select
          options={[
            { label: "Coach", value: "0" },
            { label: "Gym", value: "1" },
          ]}
          value={accountType}
          onChange={(val) => updateAccountType(val)}
          label="Account Type"
        />
        {error &&
          <ErrorMessage>
           {error}
          </ErrorMessage>
        }
        {created ? (
          <div>
           <Instructions>Your portal account has been created. Check your email for your temporary password.</Instructions>
           <Link to="/">Sign In</Link>
          </div>
        ) : (
          <Button
            label={'Submit'}
            onClick={handleSubmit}
            style={{ marginBottom: "32px" }}
          />
        )}
      </Container>
    ))
  )
}


export default withRouter(SignUp)
